import { Button, Table } from "antd";
import React from "react";
import style from "./CourseTable.module.scss";
import {
    CourseItem,
    date2Week,
    date2WeekHanzi,
    isTrue,
    sectionDescribe,
    workState
} from "service/service";
import { ColumnProps } from "antd/es/table";
import { useHistory } from "react-router-dom";

interface CourseTableProps {
    list: CourseItem[];
}

export default function CourseTable({ list }: CourseTableProps) {
    const history = useHistory();
    const columns: ColumnProps<CourseItem>[] = [
        {
            title: "周",
            dataIndex: "week",
            render: (val: string, item: CourseItem) => (
                <div>
                    第{val}周 {date2WeekHanzi(item.date)} {item.date}
                </div>
            )
        },
        {
            title: "节",
            dataIndex: "section",
            render: (val: string, item: CourseItem) => (
                <div>{sectionDescribe(val, item.continunity)}</div>
            )
        },
        {
            title: "课程信息",
            dataIndex: "courseName",
            render: (val: string, item: CourseItem) => (
                <div>
                    {val}-{item.courseSeq}
                    <p className={style.tea}>授课教师: {item?.teacherName}</p>
                </div>
            )
        },
        {
            title: "状态",
            dataIndex: "workstate",
            render: (value: string) => {
                return (
                    <div>
                        {value === workState.NoHomework && <div>未留</div>}
                        {(value === workState.HarfMark ||
                            value === workState.HaveHomework) && (
                            <div>待批改</div>
                        )}
                        {value === workState.MarkAll && <div>已批改</div>}
                    </div>
                );
            }
        },
        {
            title: "操作",
            dataIndex: "action",
            width: 200,
            render: (value: string, item: CourseItem) => (
                <div className={style.operation}>
                    <Button
                        onClick={() =>
                            window.open(
                                `/homework/edit/${item.courseNo}/${
                                    item.courseSeq
                                }/${item.week}/${date2Week(item.date)}/${
                                    item.section
                                }/${item.continunity}/${item.weekTimeId}`
                            )
                        }
                        disabled={isTrue(item.readOnly)}
                        className={style.Button}
                        type="primary">
                        留作业
                    </Button>

                    {item.workstate !== workState.NoHomework && (
                        <Button
                            onClick={() =>
                                history.push(
                                    `/homework/review/list/${item.courseNo}/${
                                        item.courseSeq
                                    }/${item.week}/${date2Week(item.date)}/${
                                        item.section
                                    }/${item.continunity}/${item.weekTimeId}`
                                )
                            }
                            className={style.Button}
                            disabled={isTrue(item.readOnly)}
                            type="default">
                            {item.workstate === workState.MarkAll
                                ? "重新判卷"
                                : "批作业"}
                        </Button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className={style.root}>
            <Table
                rowKey="key"
                columns={columns}
                dataSource={list || []}
                bordered
                pagination={false}
            />
        </div>
    );
}
